import React from "react";
import useDeviceDetect from "../../../../../hook/useDeviceDetect";

export default function Round(props: any) {
  const { value, lang } = props;
  const { isTablet } = useDeviceDetect();
  return (
    <div
      className={`wrap-item wrap-item-round
    animate__animated
    
    ${isTablet ? "animate__zoomIn" : "animate__fadeInRight"}
    `}
    >
      <p className="label-round">
        {lang?.round || "Round"} #{value}
      </p>
      <p className="label-complete">{lang?.completed || "completed"}</p>
    </div>
  );
}
